import { Logout, Notification, NotificationNew, User } from "@carbon/icons-react";
import { HeaderGlobalAction, HeaderGlobalBar } from '@carbon/react';
import { useSelector } from "react-redux";
import { selectNotifications, selectNavigationIcons } from "../../../features/application/applicationSlice.js";

const HeaderGlobal = ({ onProfileClick, onNotificationsClick, onLogoutClick }) => {
    const notifications = useSelector(selectNotifications);
    const { profile: navProfile, notifications: navNotifications } = useSelector(selectNavigationIcons);

    return (
        <HeaderGlobalBar className="mm-header-global">
            {navProfile.active && (
                <HeaderGlobalAction aria-label="Perfil"
                    onClick={() => onProfileClick(navProfile)}><User />
                </HeaderGlobalAction>
            )}
            {navNotifications.active && (
                <HeaderGlobalAction aria-label="Notificationes"
                    onClick={() => onNotificationsClick(navNotifications)}>
                    {notifications.length > 0 &&
                        <NotificationNew />}
                    {notifications.length === 0 &&
                        <Notification />}
                </HeaderGlobalAction>
            )}
            <HeaderGlobalAction aria-label="Salir"
                onClick={onLogoutClick}><Logout />
            </HeaderGlobalAction>
        </HeaderGlobalBar>
    );
};

export default HeaderGlobal;